import { supabase } from '@/integrations/supabase/client';

const BASE = () => (import.meta.env.VITE_SUPABASE_URL as string) ?? 'https://beta.crm-api.primetecia.com.br/api';

export type Fonte = 'LEAD' | 'RECEITA' | 'ACHATUDO' | 'ASSERTIVA';

export type CardPronto =
  | { tipo: 'frase'; titulo: string; partes: Array<{ texto: string; destaque: boolean }>; selos: string[] }
  | { tipo: 'numeros'; titulo: string; meta: string | null; itens: Array<{ rotulo: string; valor: string }> }
  | { tipo: 'linhas'; titulo: string; itens: Array<{ rotulo: string; valor: string }> }
  | { tipo: 'selos'; titulo: string; selos: string[] }
  | { tipo: 'lista'; titulo: string; colunas: string[]; linhas: string[][] };

export interface Camada1 { chave: string; nome: string; historia: string; cards: CardPronto[] }

export interface Endereco {
  logradouro: string | null; numero: string | null; complemento: string | null; bairro: string | null;
  cidade: string | null; uf: string | null; cep: string | null;
}

export interface Empresa {
  cnpj: string; razaoSocial: string | null; nomeFantasia: string | null; situacao: string | null; desde: string | null;
  porte: string | null; natureza: string | null; mei: boolean | null; simples: boolean | null; atividade: string | null;
  capital: number | null; endereco: Endereco | null; fontes: Fonte[];
}

export interface Pessoa {
  cpf: string | null; cpfMascarado: string | null; nome: string; cargo: string | null; idade: number | null;
  faixaEtaria: string | null; cidade: string | null; fontes: Fonte[];
}

export interface Contato {
  tipo: 'telefone' | 'email'; valor: string; deQuem: { cpf: string | null; nome: string } | null; fontes: Fonte[];
  operadora: string | null; whatsapp: boolean | null;
}

export interface Camada2 {
  documento: { tipo: 'CNPJ' | 'CPF'; numero: string };
  empresa: Empresa | null;
  pessoas: Pessoa[];
  contatos: Contato[];
  cobertura: { claro: { tipo: string | null; velocidadeMax: number | null } | null };
  outrasEmpresas: Array<{ cnpj: string; razaoSocial: string | null; situacao: string | null }>;
}

export interface DadosPadrao {
  camada1: Camada1 | null;
  contatoReal: { nome: string | null; telefone: string | null; email: string | null };
  camada2: Camada2 | null;
}

/** A aba Dados em duas camadas (services/leads/dados-padrao.service.ts). */
export async function buscarDadosPadrao(leadId: string, completar: boolean): Promise<DadosPadrao | null> {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) throw new Error('Sessão expirada — faça login novamente.');
  const response = await fetch(`${BASE()}/v1/leads-carteira/${leadId}/dados-padrao${completar ? '?completar=1' : ''}`, {
    headers: { Authorization: `Bearer ${session.access_token}` },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body?.error || 'Não foi possível buscar os dados deste lead.');
  return (body.data ?? null) as DadosPadrao | null;
}
